export default __webpack_public_path__ + "static/media/M1-male-01_mos_MPOL.c8a984c7.wav";